import 'projects/sharedComponents/src/pet/careResources/links/careResourcesOtherLink.scss';

import { HeapCategory, HeapMetadata } from 'clientServerShared/types/eventTracking';

import { CareResourcesOtherLinkFragment } from 'projects/sharedComponents/src/generated/contentful-graphql-types';
import { ContentfulLink } from 'projects/sharedComponents/src/pet/careResources/contentful/links/contentfulLink';
import { FC } from 'react';
import { PersonalizedVariableContentFragment } from 'projects/sharedComponents/src/generated/graphql-client-types';
import { Typography } from '@mui/material';
import clsx from 'clsx';
import { getHeapDataAttributes } from 'projects/sharedComponents/src/services/eventTracking/eventTracking';

export type CareResourcesOtherLinkProps = {
  pet: PersonalizedVariableContentFragment;
  link: CareResourcesOtherLinkFragment;
} & Pick<HeapMetadata, 'heapValue'>;

export const CareResourcesOtherLink: FC<CareResourcesOtherLinkProps> = (props) => {
  const { pet, link, heapValue } = props;
  const url = link.url ?? '';

  const isBreedLink = url.includes('/breeds/');

  const imageClassName = !isBreedLink
    ? 'careResourcesProduct-fullHeightImage'
    : 'careResourcesOtherLink-breedImageContainer';

  return (
    <ContentfulLink
      pet={pet}
      href={url}
      className="careResourcesProduct careResourcesOtherLink"
      {...getHeapDataAttributes({
        heapCategory: HeapCategory.CARE_RESOURCES,
        heapAction: 'Click Care Resources Link',
        heapDetails: link.title ?? undefined,
        heapValue,
      })}
    >
      {/* The link image */}
      <div className={clsx('careResourcesProduct-imageContainer', imageClassName)}>
        <div className="careResourcesProduct-imageBorder">
          {!!link.image?.url && <img className="careResourcesProduct-image" src={link.image.url} alt="" />}
        </div>
      </div>

      {/* The title of the link*/}
      <div className="careResourcesProduct-productInfoContainer">
        <div className="careResourcesProduct-title">
          <Typography variant="body1">
            <b className="careResourcesProduct-productName">{link.title}</b>
          </Typography>
        </div>
      </div>
    </ContentfulLink>
  );
};
